import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { QuotationVersionModel } from 'src/app/models/preliminaries/quotation-version.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { QuotationVersionTableModel } from 'src/app/models/tables/preliminaries/quotation-version-table.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class QuotationVersionService {

  constructor(private _httpClient: HttpClient) { }

  getAllQuotationVersion(): Observable<Array<QuotationVersionModel>> {
    return this._httpClient.get<Array<QuotationVersionModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotationVersion.GetAllQuotationVersions}`);
  }

  getColumnsForConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotationVersion.GetColumnsForConsultation}`);
  }

  getAllQuotationVersionsWithPagination(quotationId: number, page: number, limit: number, columnSort: string | null, ascendant: boolean): Observable<PagedResponseModel<QuotationVersionTableModel>> {
    const params = new HttpParams()
      .set('quotationId', quotationId)
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant);

    return this._httpClient.get<PagedResponseModel<QuotationVersionTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotationVersion.GetAllQuotationVersionsWithPagination}`,
      { params: params }
    );
  }

  getQuotationVersionById(quotationVersionId: number): Observable<QuotationVersionModel> {
    return this._httpClient.get<QuotationVersionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotationVersion.GetQuotationVersionById}/${quotationVersionId}`);
  }

  getQuotationVersionsForSelect(quotationId: number): Observable<any> {
    return this._httpClient.get<any>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotationVersion.GetQuotationVersionsForSelect}/${quotationId}`);
  }

  getSellerByIdForSelect(sellerId: number): Observable<any> {
    return this._httpClient.get<any>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.GetSellerByIdForSelect}/${sellerId}`);
  }


  createQuotationVersion(quotationVersionModel: QuotationVersionModel): Observable<QuotationVersionModel> {
    return this._httpClient.post<QuotationVersionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotationVersion.CreateQuotationVersion}`,
      quotationVersionModel);
  }

  updateQuotationVersion(quotationVersionModel: QuotationVersionModel): Observable<QuotationVersionModel> {
    return this._httpClient.put<QuotationVersionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotationVersion.UpdateQuotationVersion}`,
      quotationVersionModel);
  }

  deleteQuotationVersion(quotationVersionId: number): Observable<QuotationVersionModel> {
    return this._httpClient.delete<QuotationVersionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotationVersion.DeleteQuotationVersion}/${quotationVersionId}`);
  }

  setActive(quotationVersionId: number): Observable<QuotationVersionModel> {
    return this._httpClient.put<QuotationVersionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotationVersion.SetActive}/${quotationVersionId}`,
      null);
  }

  getQuotationVersionsByQuotationId(quotationId: number): Observable<Array<QuotationVersionModel>> {
    return this._httpClient.get<Array<QuotationVersionModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotationVersion.GetQuotationVersionsByQuotationId}/${quotationId}`);
  }

  getLastQuotationVersion(quotationId: number): Observable<QuotationVersionModel> {
    return this._httpClient.get<QuotationVersionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotationVersion.GetLastQuotationVersion}/${quotationId}`);
  }

  getQuotationVersionByKeys(quotationId: number, consecutive: number): Observable<QuotationVersionModel> {
    return this._httpClient.get<QuotationVersionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotationVersion.GetQuotationVersionByKeys}/${quotationId}/${consecutive}`);
  }

}
